import { render, staticRenderFns } from "./DetallesAlerta.vue?vue&type=template&id=0a9049e8&"
import script from "./DetallesAlerta.vue?vue&type=script&lang=js&"
export * from "./DetallesAlerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports